import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-mobile-lined",
  "use": "rt-base-mobile-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-mobile-lined\"><path d=\"M744 112H280c-35.3 0-64 28.7-64 64v672c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64z m-8 728H288V184h448v656z\" /><path d=\"M446 688c0 36.5 29.5 66 66 66s66-29.5 66-66-29.5-66-66-66-66 29.5-66 66z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/mobile-lined.svg
// module id = 1768
// module chunks = 137